import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Figure,
  Image,
  ListGroup,
  Row,
} from "react-bootstrap";
import { Phone } from "lucide-react";
import { MdEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa";
import { getMaritalByIdApi } from "../../../hooks/ApisContainer/Matrimonial";
import { useParams } from "react-router-dom";
import useToastContext from "../../../hooks/useToastContext";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import moment from "moment";
import { BASE_URL } from "../../../services/path";

const ViewBiodata = () => {
  const notification = useToastContext();
  const { id } = useParams();

  const [maritalDetail, setMaritalDetail] = useState({});
  const [loader, setLoader] = useState(false);
  const fetchedGetMaritalById = () => {
    getMaritalByIdApi({ id }, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setMaritalDetail(response);
      }
    });
  };

  useEffect(() => {
    if (id?.length === 24) {
      fetchedGetMaritalById();
    }
  }, [id]);

  console.log("maritalDetail", maritalDetail?.multipleImage);
  return (
    <div className="right-panel p-3">
      {loader ? (
        <Container className="d-flex justify-content-center align-items-center default-back">
          <span>
            <LottiLoader height={120} width={120} loader={true} />
          </span>
        </Container>
      ) : (
        <Card className="mx-auto shadow text-start resume-format">
          <Card.Body>
            <Row className="p-3 justify-content-center align-items-center">
              <Col md={3} className="text-center">
                <Image
                  src={`${BASE_URL}/uploads/${maritalDetail.image}`}
                  roundedCircle
                  className="mb-3"
                  alt="Profile Picture"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                  }}
                />
              </Col>
              <Col md={5} className="">
                <div className="ms-5">
                  <h2 className="fw-bold">{`${maritalDetail?.firstName} ${maritalDetail?.lastName}`}</h2>
                  <h5 className="text-muted">
                    {maritalDetail?.professionalDetails?.officeDesignation}
                  </h5>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-4">
                  <h5 className="fw-bold">D.O.B :</h5>
                  <p>
                    Date:{" "}
                    {moment(maritalDetail?.birthDetails?.dob).format(
                      "DD MMM YYYY"
                    )}
                  </p>
                  <p>Time: {maritalDetail?.birthDetails?.timeOfBirth}</p>
                  <p>Place: {maritalDetail?.birthDetails?.placeOfBirth}</p>
                </div>

                <div className="mb-4">
                  <h5 className="fw-bold">DETAILS :</h5>
                  <p>
                    <strong>Religion:</strong> {maritalDetail?.religion}
                  </p>
                  <p>
                    <strong>Height:</strong> {maritalDetail?.height}
                  </p>
                  <p>
                    <strong>Weight:</strong> {maritalDetail?.weight} kg
                  </p>
                </div>

                {maritalDetail?.professionalDetails?.officeDesignation &&
                  maritalDetail?.professionalDetails?.officeName &&
                  maritalDetail?.professionalDetails?.officeAddress && (
                    <div className="mb-4">
                      <h5 className="fw-bold">PROFESSION :</h5>
                      <p>
                        <strong>
                          {
                            maritalDetail?.professionalDetails
                              ?.officeDesignation
                          }{" "}
                          at {maritalDetail?.professionalDetails?.officeName},{" "}
                          {maritalDetail?.professionalDetails?.officeAddress}
                        </strong>
                      </p>
                      <p>{maritalDetail?.professionalDetails?.description}</p>
                    </div>
                  )}

                <div className="mb-4 contact-info">
                  <h5 className="fw-bold">CONTACT :</h5>
                  <ListGroup variant="flush">
                    <ListGroup.Item>
                      <figure>
                        <Phone />
                      </figure>
                      +91{" "}
                      {maritalDetail?.contactPersonInformation?.mobileNumber} -{" "}
                      {maritalDetail?.contactPersonInformation?.name}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <figure>
                        <MdEmail />
                      </figure>
                      {maritalDetail?.contactPersonInformation?.email}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <figure>
                        <IoLocationOutline />
                      </figure>
                      {maritalDetail?.address?.city},{" "}
                      {maritalDetail?.address?.country}{" "}
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-4">
                  <h5 className="fw-bold">EDUCATION QUALIFICATIONS :</h5>
                  <ul>
                    <li>
                      {maritalDetail?.education?.degree},{" "}
                      {maritalDetail?.education?.collegeName} -{" "}
                      {maritalDetail?.education?.yearOfPassing}
                    </li>
                  </ul>
                </div>

                {/* Family Section */}
                <div className="mb-4">
                  <h5 className="fw-bold">FAMILY BACKGROUND :</h5>
                  <ul>
                    {maritalDetail?.familyInformation?.map((item, index) => (
                      <Fragment key={index}>
                        <li>
                          {item?.relationWith[0].toUpperCase() +
                            item?.relationWith.slice(1)}{" "}
                          Name: {`${item.firstName} ${item.lastName}`}
                        </li>
                        <li>Occupation: {item.occupation}</li>
                      </Fragment>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
            <Row className="achiever-box gx-2">
              {maritalDetail?.multipleImage &&
                maritalDetail?.multipleImage.length > 0 &&
                maritalDetail?.multipleImage.map((item, index) => {
                  console.log("item", item);
                  return (
                    <Col
                      lg={3}
                      md={4}
                      xs={6}
                      className="mb-3 box-member"
                      key={index}
                    >
                      <Card className="sponser-cards gallery-box position-relative">
                        <Figure>
                          <Card.Img
                            variant="top"
                            src={`${BASE_URL}/uploads/${item}`} // If you need to dynamically load images
                            alt="No_Image"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                            }}
                          />
                        </Figure>
                      </Card>
                    </Col>
                  );
                })}
            </Row>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default ViewBiodata;

// No of Members,no of volumnteers,no of Active user
